import { JetView } from 'webix-jet';

/**
 * Class representing the details view of a casino report.
 * @extends JetView
 */
export default class detailsCasinoReportView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Current screen size

        // Main information form configuration
        const main_info = {
            margin: 10,
            rows: [
                {
                    view: 'text',
                    name: 'Id',
                    label: _("<span class='icon-id'></span> ID"), // ID label with icon
                    labelPosition: 'top',
                    placeholder: _('Id'), // Placeholder for ID
                    invalidMessage: _('A ID is required'), // Validation message
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'TransactionId',
                    label: _('Transacción Id'), // Transaction ID label
                    labelPosition: 'top',
                    placeholder: _('Transacción Id'), // Placeholder for Transaction ID
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Type',
                    label: _('Tipo'), // Type label
                    labelPosition: 'top',
                    placeholder: _('Tipo'), // Placeholder for Type
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Amount',
                    label: _('Valor'), // Amount label
                    labelPosition: 'top',
                    placeholder: _('Valor'), // Placeholder for Amount
                    disabled: true, // Field is disabled
                    id: 'Valor', // Unique ID for the Amount field
                },
                {
                    view: 'text',
                    name: 'Response',
                    label: _('Respuesta'), // Response label
                    labelPosition: 'top',
                    placeholder: _('Respuesta'), // Placeholder for Response
                    disabled: true, // Field is disabled
                },
            ],
        };

        // Left main section configuration
        const left_main = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [main_info], // Contains the main_info form
        };

        // Upper section configuration for larger screens
        const upper_section = {
            multiview: true, // Allows multiple views
            scroll: true, // Enables scrolling
            cols: [left_main, { gravity: 1, minWidth: 20 }], // Layout columns
        };

        // Upper section configuration for narrow screens
        const upper_section_narrow = {
            cols: [
                {
                    gravity: 4,
                    margin: 10,
                    rows: [main_info], // Contains the main_info form
                },
            ],
        };

        // Return the main form configuration
        return {
            view: 'form',
            rows: [screen !== 'small' ? upper_section : upper_section_narrow], // Conditional layout based on screen size
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance.
     */
    init(form) {
        // Event listener for selecting a casino transaction detail
        this.on(this.app, 'casinoTransDetail:select', (person) => {
            form.setValues(person); // Set form values based on selected person
            this.$$('Valor').setValue(webix.i18n.priceFormat(person.Amount)); // Format and set the Amount value
        });
    }
}

// FILE DOCUMENTED
